import { Page } from '../../../components';
import { useMediaQuery } from '@mui/material';
import { TestBuildsList } from './test-builds-list';

export const TestBuildsPage = () => {
  const removeStickyHeader = useMediaQuery('(max-width: 1246px)');

  return (
    <Page pageHasStickyHeaders={removeStickyHeader ? false : true} title="Test Builds">
      <TestBuildsList />
    </Page>
  );
};
